import React from 'react';

import styles from './LocalAdminConsole.module.scss';
import { UNREACHABLE } from './pages/OfflineMode/copy';

export type ConsoleUnreachableProps = {
  apiBaseUrl: string;
  organizationName: string;
  onRetry: () => void;
};

export default function ConsoleUnreachable({
  apiBaseUrl,
  organizationName,
  onRetry,
}: ConsoleUnreachableProps) {
  return (
    <div className={styles.unreachable} role="alert" data-test-id="localConsoleUnreachable">
      <h2 className={styles.unreachableTitle}>{UNREACHABLE.title}</h2>

      <p className={styles.unreachableBody} data-test-id="localConsoleUnreachableReassurance">
        {UNREACHABLE.reassurance}
      </p>

      <div className={styles.field}>
        <span className={styles.fieldLabel}>{UNREACHABLE.deploymentLabel}</span>
        <span className={styles.fieldValue} data-test-id="localConsoleUnreachableEndpoint">
          {apiBaseUrl || 'not resolved'}
        </span>
      </div>

      {organizationName ? (
        <div className={styles.field}>
          <span className={styles.fieldLabel}>Organization</span>
          <span className={styles.fieldValue}>{organizationName}</span>
        </div>
      ) : null}

      <p className={styles.unreachableBody} data-test-id="localConsoleUnreachableAccessPath">
        {UNREACHABLE.accessPath}
      </p>
      <p className={styles.unreachableBody}>{UNREACHABLE.escalation}</p>

      <button
        type="button"
        className={styles.unreachableRetry}
        data-test-id="localConsoleUnreachableRetry"
        onClick={onRetry}
      >
        {UNREACHABLE.retryLabel}
      </button>
    </div>
  );
}
